import PropTypes from "prop-types"
import React from "react"

import { InlineText } from "../../../Typography/Typography"

const labelText = {
  care_home: "Care Home",
  home_care: "Home Care Agency",
}

function CareTypeLabel({ careType }) {
  return (
    <InlineText light uppercase marginBottom>
      {labelText[careType]}
    </InlineText>
  )
}

CareTypeLabel.propTypes = {
  careType: PropTypes.oneOf(["home_care", "care_home"]).isRequired,
}

export default CareTypeLabel
